import React from "react";

const DashboardWidgetWrapper = ({
  widget,
  editMode,
  isResizing,
  onRemove,
  onResizeStart,
  isDraggedOver,
  onDragStart,
  onDragOver,
  onDragEnd,
  onDrop,
  children,
}) => {
  const style = {
    gridColumn: `span ${widget.w}`,
  };
  if (widget.h) {
    style.minHeight = `${widget.h}px`;
  }

  return (
    <div
      className={`dashboard-widget${editMode ? " editable" : ""}${isDraggedOver ? " drag-over" : ""}${isResizing ? " resizing-active" : ""}`}
      style={style}
      draggable={editMode && !isResizing}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
      onDrop={onDrop}
    >
      <div className="widget-header">
        <span className="widget-title">{widget.label}</span>
        {editMode && (
          <div className="widget-controls">
            <button className="widget-remove-btn" onClick={onRemove}>
              x
            </button>
          </div>
        )}
      </div>
      <div className="widget-body">{children}</div>
      {editMode && (
        <>
          <div
            className="resize-handle resize-right"
            onMouseDown={(e) => onResizeStart("right", e)}
          />
          <div
            className="resize-handle resize-bottom"
            onMouseDown={(e) => onResizeStart("bottom", e)}
          />
          <div
            className="resize-handle resize-corner"
            onMouseDown={(e) => onResizeStart("corner", e)}
          />
        </>
      )}
    </div>
  );
};

export default DashboardWidgetWrapper;
